import dotenv from 'dotenv'
dotenv.config({ path:"./.env" })

const checkSignInStatus = async (userType, credentials, authorizationToken, cookie, xSource) => {
  // console.log('XSTATUS', userType, credentials, authorizationToken, cookie, xSource)
  /*
    On backEnd, in /api/auth/status/route.js
    Cookie can be retrieved in multiple ways. 
    Here's how cookie is retrieved:
    > const tokenCookie = req?.cookies?._parsed?.get('token')?.value || req.cookies.token || req.headers.cookies || req.headers.authorization || req.headers.get('Authorization')

    *** At the time of this comment, only /app/[lang]/talent/[talent]/page.js uses "cookie", nothing uses authorizationToken, everything else uses credentials: include
  */

  try {
    // state.setLoading(true)
     const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co'
     const response = await fetch(`${baseUrl}/api/auth/status?user_type=${userType}`, { // add http://localhost:3000 if doesn't work 
          method: 'GET', // Use uppercase for HTTP methods
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json',
            'Cookie': cookie,
            // 'Authorization': `Bearer ${authorizationToken}` ,
             ...(authorizationToken && {'Authorization': `Bearer ${authorizationToken}`,}),
            'X-Source': xSource
          },
          credentials: credentials, // If you are sending cookies with a cross-origin request, use 'include'
        });
    // console.log("RESPONSE@SIGNIN_STATUS", await response.json())

    // If the server responds with a success status (e.g., 200), the user is logged in
    // state.setLoading(false)
    return response.status === 200
  } catch (error) {
    // If there's an error or the server responds with an error status, the user is not logged in
    console.error('RESPONSE@STATUS checkSignInStatusError', error)
    // state.setLoading(false)
    return false
  }
};

export default checkSignInStatus








// import axios from "axios";

// const checkSignInStatus = async () => {
//   try {
//      const response = await axios.get('http://localhost:3000/api/auth/status', {
//           // method: 'GET', // Use uppercase for HTTP methods
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },

//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//         });
//     console.log("RESPONSE@STATUS", await response.json())

//     // If the server responds with a success status (e.g., 200), the user is logged in
//     return response.status === 200
//   } catch (error) {
//     // If there's an error or the server responds with an error status, the user is not logged in
//     console.log('checkSignInStatusError', error)
//     return false
//   }
//  //  finally {setLoading(false)}

// };


